<div class="w100 l-flex-w t-boxMargin--spacebyPadding summary" *ngIf="examId && ! ls.ishospital">
  <div class="w100">
    <section class="m-box">
      <h2>
        HMO
      </h2>
      <div class="l-flex-c l-flex-w indicative-fieldset" (dblclick)="HMO !== null && save(null)">
        <label class="t-label" *ngFor="let payer of payers">
          <input type="radio" name="examPayer" [value]="payer" [checked]="HMO === payer" (change)="save(payer)" class="custom-check -sq" />
          <i class="customInput-display -sq"></i>
          <span>
            {{payer}}
          </span>
        </label>
      </div>
      <p *ngIf="error" style="color: rgb(243, 63, 53); width: 100%; margin: 0;">Failed to save, please try again</p>
      <app-financial-status [examId]="examId"></app-financial-status>
    </section>
  </div>
</div>
